import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ItemsList } from 'src/pages';
import replaceText from 'src/utils/replaceText';

const ViewCategory = () => {
  const { id }: any = useParams();

  useEffect(() => {
    // Find and replace text in the page

    // Call replaceText when the component mounts
    replaceText();
  }, [id]);

  return <ItemsList />;
};

export default ViewCategory;
